module.exports = __webpack_public_path__ + "static/media/img5.c1a2c577.png";